import React, { useState } from "react";
import { Box } from "@mui/material";
import TimePicker from "../../../Components/TimePicker";
import { TTimeTrigger } from "./types";
import { useTranslation } from "react-i18next";

interface ITimeTriggerFormProps {
  trigger: TTimeTrigger;
  onChange: (timeTrigger: TTimeTrigger) => void;
}

const TimeTriggerForm = (props: ITimeTriggerFormProps) => {
  const { trigger, onChange } = props;
  const [timeTrigger, setTimeTrigger] = useState<TTimeTrigger>(trigger);
  const { t } = useTranslation();

  const handleTimeChange = (key: string, time: string) => {
    const newTimeTrigger = { ...timeTrigger, [key]: time };
    setTimeTrigger(newTimeTrigger);
    onChange(newTimeTrigger);
  };

  return (
    <Box gap={1} display="flex" flexDirection="row">
      <TimePicker
        label={t("Time")}
        value={timeTrigger.at}
        onTimeChange={(time: string) => handleTimeChange("at", time)}
        sx={{ width: "50%" }}
        data-cy="time-trigger-time-picker"
      />
      <TimePicker
        label={t("Delta")}
        value={timeTrigger.delta}
        onTimeChange={(time: string) => handleTimeChange("delta", time)}
        sx={{ width: "50%" }}
        data-cy="time-trigger-delta-picker"
      />
    </Box>
  );
};

export default TimeTriggerForm;
